import React from 'react';
import { useSelector } from 'react-redux';

import ActivityComment from './ActivityComment';
import { selectArticleComments } from '../../../../store/modules/articleComments/selectors';

const ActivityComments = () => {
  const articles = useSelector(selectArticleComments);
  const activity = articles?.data?.items ? articles.data.items : [];

  return (
    <>
      {activity && activity.length
        ? activity.map(((item) => <ActivityComment key={item.id} article={item} />))
        : null}
    </>
  );
};

export default ActivityComments;
